export const isSharing = (operationType) => {
    return (operationType === "S");
}

export const isCommercial = operationType => operationType === "C";

export const isSubscription = operationType => operationType === "P";
